import axios from 'axios';
import { PRESUPUESTO } from '../constantes';
export const GET_PRESUPUESTO = 'GET_PRESUPUESTO';
export const PUT_PRESUPUESTO = "PUT_PRESUPUESTO";
export const FACTURADO = "FACTURADO";
export const COBRADO = "COBRADO";

export const getPresupuesto = () => async dispatch => {
    try {
        await axios.get(PRESUPUESTO)
            .then((res) => {
                dispatch({
                    type: GET_PRESUPUESTO,
                    payload: res.data
                })
            })
    } catch (error) {
        console.log(error);
    }
} 

// 

export const putPresupuesto = (id, payload) => async dispatch => {
    console.log(id, payload);
    
    try {
        await axios.put(`${PRESUPUESTO}/${id}`, payload, {withCredentials:true})
        .then((res) => {
            dispatch({
                type: PUT_PRESUPUESTO,
                payload: res.data
            })
        })
    } catch (error) {
        
    }
}

export const putFacturado = (id, payload) => async dispatch =>{
    console.log(payload);
    console.log(id);    
    
    try {
        await axios.put(`${PRESUPUESTO}/facturado/${id}`, payload, {headers: {
            'Content-Type': 'application/json',
        }, withCredentials:true})
         .then(res => {
            dispatch({
                type: FACTURADO,
                payload: res.data
            })           
         })
    } catch (error) {
        console.log(error);
        
    }
}

export const putCobrado = (id, payload) => async dispatch =>{
    try {
        await axios.put(`${PRESUPUESTO}/cobrado/${id}`, payload, {headers: {
            'Content-Type': 'application/json',
        }, withCredentials:true})
         .then(res => {
            dispatch({
                type: COBRADO,
                payload: res.data
            })
         })
    } catch (error) {
        console.log(error);
                
    }
}

